declare var ENV:string;
declare var HMR:boolean;
declare var process:any;
declare var API_URL:string;
declare var ASSET_URL:string;
declare var CLUB_SEARCH_ENABLED:boolean;
declare var SECURITY_ENABLED:boolean;
declare var DISPLAY_VERSIONS:boolean;
declare var REDIRECT_UNAUTHORIZED_RESPONSES:boolean;
declare var UNAUTHORIZED_REDIRECT_URL:string;
declare var AUTO_LOGIN_ENABLED:boolean;
declare var AUTO_LOGIN_MEMBER_ID:string;
declare var AUTO_LOGIN_PASSWORD:string;

export class Settings {

  public static readonly env:string = ENV;
  public static readonly hmr:boolean = HMR;
  public static readonly process:any = process;
  public static readonly apiUrl:string = API_URL;
  public static readonly assetUrl:string = ASSET_URL;
  public static readonly clubSearchEnabled:boolean = CLUB_SEARCH_ENABLED;
  public static readonly securityEnabled:boolean = SECURITY_ENABLED;
  public static readonly displayVersions:boolean = DISPLAY_VERSIONS;
  public static readonly redirectUnauthorizedResponses:boolean = REDIRECT_UNAUTHORIZED_RESPONSES;
  public static readonly unauthorizedRedirectUrl:string = UNAUTHORIZED_REDIRECT_URL;
  public static readonly autoLoginEnabled:boolean = AUTO_LOGIN_ENABLED;
  public static readonly autoLoginMemberId:string = AUTO_LOGIN_MEMBER_ID;
  public static readonly autoLoginPassword:string = AUTO_LOGIN_PASSWORD;

  constructor() { }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/settings.ts